import PropTypes from 'prop-types';
import { Link, useInRouterContext } from 'react-router-dom';

// Link to a causa's detail. Outside a Router (stories, tests of standalone
// views) it falls back to an <a>, so this link alone does not require the context.
export default function VerCausaLink({ caseId, children = 'Ver causa' }) {
  const inRouter = useInRouterContext();
  const to = `/causas/${encodeURIComponent(caseId)}`;
  return inRouter ? (
    <Link to={to}>{children}</Link>
  ) : (
    <a href={to}>{children}</a>
  );
}

VerCausaLink.propTypes = {
  caseId: PropTypes.string.isRequired,
  children: PropTypes.node,
};
